import { IonAlert, IonButton, IonCheckbox, IonIcon, IonInput, IonItem, IonLabel, IonList, IonRadio, IonRadioGroup } from '@ionic/react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Geolocation } from '@capacitor/geolocation';
import { getConfig } from '../../appConfig';
import { FieldError, NormalText, SmallText, Spacer, StrongText, Title } from '../../components/common';
import Layout from '../../components/layout';
import CuratedMenusLink from '../../components/curatedMenusLink';
import Mobiscroll from '../../components/mobiscroll';
import NoData from '../../components/noData';
import Loading from '../../components/spinner';
import api from '../../lib/api';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { checkForDeliveryOption, deepCopy, forwardTo, getDefaultRoute, goBack, isDefined, isNative, isObject, isTimeAvaibleInMenu, isWebConfig, parseAllergenData } from '../../lib/utils';
import { getIkentooMenu, getIkentooMenusForLocation, getRestaurants, loading, setCommonModal, setCommonProp, setDeliveryOption, setMyLocation, showToast } from '../../store/actions';
import { SET_RESTAURANT_PROP } from '../../store/constants';
import { filterMenu } from '../../store/restaurants/sagas';
import { formatDataForTime, getMenusForSelectedTime, isStoreOpened } from '../clickAndCollect';
import './index.css';
import { search, searchOutline } from 'ionicons/icons';
import Modal from '../../components/modal';
import { ReactComponent as LocationDisabledIcon } from '../../assets/images/location-disabled.svg';

const { shouldAddPrepTime } = Basket;

const { SelectOption } = Mobiscroll;
const tableSelectPlaceholder = 'Select table';

class OrderToTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedRestaurant: props.location.state && props.location.state.selectedRestaurant ? props.location.state.selectedRestaurant.restaurant_id : null,
			error: '',
			isLocationAllowed: false,
			tableNumber: props.location?.state?.saveOrderData
				? Basket.getTableNumber()
				: props.location?.state?.selectedRestaurant
					? props.location.state.selectedRestaurant.table_name
					: getConfig().flags.tableNumberPicker
						? null
						: '',
			showTableNumber: true,
			totalTableNumbers: [],
			tableNumberPicker: getConfig().flags.tableNumberPicker || false,
			selectedRestaurantFull: null,
			noTableRestaurants: false,
			isSubmitRestaurantAlertOpen: false,
			useSearchParams: false,
			forwardToOrdering: false,
			checkTablePlan: getConfig().flags.checkTablePlan || false,
			tableNumberError: false,
			filterValue: '',
			tableFilterValue: ''
		};
	}
	formatMultiVenueTableNumbers = () => {
		const { __ } = this.props;
		const tablePlan = getConfig().tablePlan || [];
		let tables = tablePlan.map((zone) => zone.tables.map((table) => ({ value: table.id, text: `Table ${table.table_number}`, group: zone.name, allowed_restaurant_ids: table.allowed_restaurant_ids, hidden: table.hidden || false }))).flat();

		if (!this.state.tableFilterValue || this.state.tableFilterValue == '') {
			tables = tables.filter(table => !table.hidden)
		}
		return tables;
	};
	componentDidMount() {
		this.props.dispatch(loading(true))
		const searchParams = new URLSearchParams(this.props.location.search);
		if (Basket.getDeliveryOption()?.id === 'gift-vouchers') {
			Basket.reset();
		}
		this.position();
		if (Basket.has_multi_basket) {
			Basket.setOrderType('table');
			if (this.props.location?.state?.saveOrderData) {
				this.setState({ showTableNumber: false });
			} else {
				Basket.reset();
				this.setState({ showTableNumber: true });
				if (getConfig().general.hasServiceCharge && getConfig().flags.applyAutomaticServiceCharge && getConfig().general.service_charge_modules?.includes('table')) {
					const defaultServiceCharge =
						typeof getConfig().general.defaultServiceCharge == 'string' ? JSON.stringify(getConfig().general.defaultServiceCharge) : getConfig().general.defaultServiceCharge;
					if (defaultServiceCharge) {
						Basket.setServicePercentage(parseFloat(defaultServiceCharge[1] * 100));

					}
				} else {
					Basket.setServicePercentage(0);
				}
			}
			let option = (getConfig().delivery || []).find((d) => d.id === 'table');
			Basket.setDeliveryOption(option);
			Basket.setCollectionTime(null);
			if (searchParams.get('t_id')) {
				const tableId = parseInt(searchParams.get('t_id'));
				const scannedTable = this.formatMultiVenueTableNumbers().find((table) => table.value == tableId);
				let valid = true;
				if (this.state.tableNumberPicker || this.state.checkTablePlan) {
					valid = !!scannedTable;
				}
				if (valid) {
					Basket.setTableNumber(tableId);
					Basket.setAllowedRestaurantIds(scannedTable?.allowed_restaurant_ids || []);
					this.setState({
						tableNumber: tableId,
						showTableNumber: false,
						pickTime: moment(Date.now()).format('HH:mm'),
					});
				}
			}
		} else {
			if (searchParams.get('bl_id')) {
				const deliveryOptions = getConfig().delivery.filter((deliveryOption) => deliveryOption.id === 'table');
				this.props.dispatch(setDeliveryOption(deliveryOptions[0]));
				Basket.setDeliveryOption(deliveryOptions[0]);
				this.setState({ useSearchParams: true, showTableNumber: true });
			}

			const { restaurants, profile } = this.props;
			Basket.setOrderType('table');
			if (this.state.selectedRestaurant) {
				const selectedRestaurant = restaurants.find((restaurant) => restaurant.id === this.state.selectedRestaurant);
				const orderType = getConfig().delivery.filter((el) => el.id === 'table');
				const orderTypeDisabled = orderType[0]?.isRemoved || orderType[0]?.isDisabled;
				if (selectedRestaurant.can_table_order && selectedRestaurant.is_published && !orderTypeDisabled) {
					Basket.setRestaurant(restaurants.find((restaurant) => restaurant.id === this.state.selectedRestaurant));
					this.selectRestaurant(restaurants.find((restaurant) => restaurant.id === this.state.selectedRestaurant).id);

					Basket.setServicePercentage(this.props.location.state.selectedRestaurant.service_charge_percentage);
					Basket.setCollectionTime(null);
					const tableNumbers = restaurants.find((restaurant) => restaurant.id === this.state.selectedRestaurant).table_plan_json;
					this.setState({
						totalTableNumbers: tableNumbers,
						pickTime: moment(Date.now()).format('HH:mm'),
					});
				} else {
					forwardTo('/history', { tab: 'order' });
					this.props.dispatch(showToast(this.props.__('This restaurant is currently not accepting orders'), 'warning'));
					Basket.reset();
				}
			} else if (searchParams.get('bl_id')) {
				const selectedRestaurant = this.props.restaurants.filter((restaurant) => restaurant.business_location_id === searchParams.get('bl_id'))[0];
				if (selectedRestaurant && selectedRestaurant?.can_table_order) {
					Basket.setRestaurant(selectedRestaurant);
					this.selectRestaurant(selectedRestaurant.id);
					Basket.setServicePercentage(selectedRestaurant.service_charge_percentage);
					Basket.setCollectionTime(null);
					const tableNumbers = restaurants.find((restaurant) => restaurant.id === selectedRestaurant.id).table_plan_json;
					if (searchParams.get('t_id') && this.state.tableNumberPicker) {
						const tableNumberValid = !!tableNumbers.find((number) => number.value === searchParams.get('t_id'));
						if (tableNumberValid) {
							this.setState(
								{
									tableNumber: searchParams.get('t_id'),
									totalTableNumbers: tableNumbers,
									pickTime: moment(Date.now()).format('HH:mm'),
								},
								() => {
									if (getConfig().flags.openTableMenuFromURL) {
										this.openMenuFromURL(selectedRestaurant, searchParams.get('t_id'));
									}
								},
							);
						} else {
							this.props.dispatch(showToast('Please select different table', 'warning'));
						}
					} else if (searchParams.get('t_id') && getConfig().flags.openTableMenuFromURL) {
						this.openMenuFromURL(selectedRestaurant, searchParams.get('t_id'));
					}
				} else {
					this.props.dispatch(showToast(this.props.__('Restaurant you selected is not available'), 'warning'));
					this.setState(
						{
							useSearchParams: false,
							showTableNumber: false,
							selectedRestaurant: null,
							selectedRestaurantFull: null,
							tableNumber: getConfig().flags.tableNumberPicker ? null : '',
							totalTableNumbers: [],
						},
						() => this.selectNearestAvailableRestaurant(),
					);
				}
			} else {
				this.selectNearestAvailableRestaurant();
			}
			let option = (getConfig().delivery || []).find((d) => d.id === Basket.order_type);
			Basket.setDeliveryOption(option);
			checkForDeliveryOption(Basket.getDeliveryOption(), '/order-to-table').then((deliveryOption) => {
				if (deliveryOption) {
					this.props.dispatch(getRestaurants());
					this.props.dispatch(setDeliveryOption(deliveryOption));
				}
				if (Basket.getMenu()) {
					this.setState({ selectedIkentooMenu: Basket.getMenu() });
				}

				const enabledRestaurants = restaurants.filter((store) => {
					if (isDefined(store.can_table_order) && isDefined(store.is_published)) {
						if (store.can_table_order && store.is_published) {
							return store;
						}
					}
				});
				// initValueOfSelectedRestaurant resets the basket, which would wipe the restaurant/table
				// already applied from the bl_id/t_id search params (clients with a single table-order
				// restaurant would otherwise lose the table number picked up from the URL).
				if (enabledRestaurants.length === 1 && !searchParams.get('bl_id')) {
					this.initValueOfSelectedRestaurant(enabledRestaurants, profile, deliveryOption);
				}
			});
		}
		if (!this.props.auth.loggedIn && !this.props.location?.state?.saveOrderData && getConfig().flags.showGuestUserModalBeforeOrder) {
			this.props.dispatch(setCommonProp('guestUserActionsModalOpen', true));
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { restaurants } = this.props;
		if (this.state.isLocationAllowed !== prevState.isLocationAllowed && !this.state.useSearchParams) {
			const filteredRestaurants = restaurants.filter((store) => store.opened && isDefined(store.can_table_order) && isDefined(store.is_published) && store.can_table_order && store.is_published);
			if (filteredRestaurants.length > 0) {
				let byDistance = filteredRestaurants;
				byDistance.sort(function (a, b) {
					return a.distance - b.distance;
				});
				Basket.setRestaurant(byDistance[0]);
				this.selectRestaurant(byDistance[0].id);
			}
		}
		if (!Basket.has_multi_basket) {
			if (this.state.selectedRestaurant !== prevState.selectedRestaurant && this.state.selectedRestaurant) {
				const selectedRestaurant = restaurants.find((restaurant) => restaurant.id === this.state.selectedRestaurant);
				const tableNumbers = selectedRestaurant.table_plan_json;
				this.setState({
					totalTableNumbers: tableNumbers,
				});
			}
		}
	}

	selectNearestAvailableRestaurant = () => {
		const { restaurants } = this.props;
		const filteredRestaurants = restaurants.filter(
			(store) => store.opened && isDefined(store.can_table_order) && isDefined(store.is_published) && store.can_table_order && store.is_published,
		);
		if (filteredRestaurants.length > 0) {
			let byDistance = filteredRestaurants;
			byDistance.sort(function (a, b) {
				return a.distance - b.distance;
			});
			if (!getConfig().flags.hasDisabledLocationRestaurantsFilter) {
				Basket.setRestaurant(byDistance[0]);
				this.selectRestaurant(byDistance[0].id);
			}
		} else {
			this.setState({
				noTableRestaurants: true,
				selectedRestaurant: null,
				showTableNumber: false,
				tableNumber: null,
				totalTableNumbers: [],
			});
		}
	};

	initValueOfSelectedRestaurant = (restaurants, profile, deliveryOption) => {
		const stores = (restaurants || []).forEach((itm) => {
			if (itm?.id && itm?.name) {
				if (isDefined(itm.can_table_order) && isDefined(itm.is_published)) {
					if (itm.can_table_order && itm.is_published) {
						this.setState(
							{
								selectedRestaurant: itm.id,
								pickTime: moment(Date.now()).format('HH:mm'),
							},
							() => {
								Basket.reset(profile?.cardToken);
								Basket.setRestaurant(restaurants.find((restaurant) => restaurant.id === itm.id));
								if (getConfig().general.hasServiceCharge && getConfig().general.service_charge_modules?.includes('table')) {
									if (getConfig().flags.applyAutomaticServiceCharge) {
										if (Basket.getRestaurantServiceCharge()) {
											const service_charge_original = Basket.getRestaurantServiceCharge();
											Basket.setServicePercentage(Number((service_charge_original[1] * 100).toFixed(2)));
										} else {
											const defaultServiceCharge =
												typeof getConfig().general.defaultServiceCharge == 'string'
													? JSON.stringify(getConfig().general.defaultServiceCharge)
													: getConfig().general.defaultServiceCharge;
											if (defaultServiceCharge) {
												Basket.setServicePercentage(Number((defaultServiceCharge[1] * 100).toFixed(2)));
											}
										}
									} else {
										Basket.setServicePercentage(0);
									}
								} else {
									Basket.setServicePercentage(0);
								}
								Basket.setCollectionTime(null);
								Basket.setOrderType('table');
								Basket.setDeliveryOption(deliveryOption);
							},
						);
					}
				}
			}
			return null;
		});

		return stores;
	};

	openMenuFromURL = (restaurant, tableId) => {
		this.setState(
			{
				selectedRestaurant: restaurant.id,
				tableNumber: tableId,
				useSearchParams: true,
				pickTime: moment(Date.now()).format('HH:mm'),
			},
			() => {
				Basket.setRestaurant(restaurant);
				Basket.setTableNumber(tableId);
				this.chooseMenusForLocation();
			},
		);
	};

	selectRestaurant = (data) => {
		const { restaurants, profile } = this.props;
		const selectedRestaurantId = data;
		if (Basket.has_multi_basket) {
			Basket.setRestaurant(restaurants.find((restaurant) => restaurant.id === selectedRestaurantId));
			Basket.setCuratedMenu(false);
			if (this.props.location?.state?.saveOrderData) {
				this.setState(
					{
						tableNumber: Basket.getTableNumber(),
						pickTime: moment(Date.now()).format('HH:mm'),
					},
					() => {
						this.chooseMenusForLocation();
					},
				);
			} else {
				this.chooseMenusForLocation();
			}
		} else {
			this.setState(
				{
					selectedRestaurant: selectedRestaurantId,
					pickTime: moment(Date.now()).format('HH:mm'),
					showTableNumber: true,
					selectedRestaurantFull: restaurants.find((restaurant) => restaurant.id === selectedRestaurantId),
				},
				() => {
					Basket.reset(profile.cardToken);
					Basket.setRestaurant(restaurants.find((restaurant) => restaurant.id === selectedRestaurantId));
					if (Basket.getRestaurant()) {
						if (getConfig().general.hasServiceCharge && getConfig().general.service_charge_modules?.includes('table')) {
							if (getConfig().flags.applyAutomaticServiceCharge) {
								if (Basket.getRestaurantServiceCharge()) {
									const service_charge_original = Basket.getRestaurantServiceCharge();
									Basket.setServicePercentage(Number((service_charge_original[1] * 100).toFixed(2)));
								} else {
									const defaultServiceCharge =
										typeof getConfig().general.defaultServiceCharge == 'string'
											? JSON.stringify(getConfig().general.defaultServiceCharge)
											: getConfig().general.defaultServiceCharge;
									if (defaultServiceCharge) {
										Basket.setServicePercentage(Number((defaultServiceCharge[1] * 100).toFixed(2)));
									}
								}
							} else {
								Basket.setServicePercentage(0);
							}
						} else {
							Basket.setServicePercentage(0);
						}
					}
					Basket.setCollectionTime(null);
					Basket.setOrderType('table');
					Basket.setDeliveryOption(this.props.deliveryOption);
				},
			);
		}
		Basket.setOrderType('table');
	};

	selectTableNumber = (event, data) => {
		const tableId = data.getVal();
		this.setState({
			tableNumber: tableId,
		});
	};

	formatDataForSelect = (stores, showAll = false) => {
		let arrForSelect = [];
		stores.forEach((store) => {
			if ((isDefined(store.can_table_order) && isDefined(store.is_published) && store.can_table_order) || (showAll && store.is_published)) {
				const currentDT = moment().tz(getConfig().timezone);
				let minDT = currentDT;
				if (store && isDefined(store.order_slot_lead_time) && shouldAddPrepTime()) {
					minDT.add(store.order_slot_lead_time, 'minutes');
				}
				const availableSlots = isTimeAvaibleInMenu(store.table_json_time_selector, currentDT);
				const storeOpened = isStoreOpened(store);
				store.opened = storeOpened && availableSlots;
				arrForSelect.push(store);
			}
		});
		return arrForSelect;
	};

	formatTableNumberForSelect = (selectedRestaurantId) => {
		const { __ } = this.props;
		let arrForSelect = [];
		if (selectedRestaurantId) {
			(this.state.totalTableNumbers || []).map((table) => {
				arrForSelect.push({ text: table.name, value: table.value });
			});
		}
		if (!this.state.tableFilterValue || this.state.tableFilterValue == '') {
			arrForSelect = arrForSelect.filter(table => !table.hidden)
		}
		return [...arrForSelect];
	};

	getMenuForReorder = (menus, reorderItems) => {
		let menuForReorder = [];
		for (let i = 0; i < menus.length; i++) {
			let foundItems = 0;
			const categoryItems = menus[i].menuEntry || menus[i].menuEntryGroups || null;
			let items = Basket.flattenMenuItems(deepCopy(categoryItems));
			menus[i].flattenMenuItems = items;
			if (items.length > 0) {
				for (let j = 0; j < reorderItems.length; j++) {
					let foundItem = items.find((i) => i.sku === reorderItems[j].item.sku);
					if (foundItem) {
						foundItems = foundItems + 1;
					}
				}
			}
			menus[i].foundItems = foundItems;
			menuForReorder.push(menus[i]);
		}
		menuForReorder.sort((a, b) => b.foundItems - a.foundItems);
		if (menuForReorder[0] && menuForReorder[0].foundItems > 0) {
			return filterMenu(menuForReorder[0]);
		} else {
			return false;
		}
	};
	getKitchenStatusColor(status) {
		let color = '';
		switch (status) {
			case 0:
				color = 'success';
				break;
			case 1:
				color = 'warning';
				break;
			case 2:
				color = 'danger';
		}
		return color;
	}
	chooseMenusForLocation = async () => {
		const { __, restaurants, dispatch } = this.props;
		const { selectedRestaurant, tableNumber, pickTime } = this.state;
		this.setState({ continueButtonClicked: true, isSubmitRestaurantAlertOpen: false }, async () => {
			if (selectedRestaurant && tableNumber && pickTime) {
				const choosenRestaurant = restaurants.find((restaurant) => restaurant.id === selectedRestaurant);
				const businessLocationId = choosenRestaurant.business_location_id;
				let cutoffTimeRes = moment().unix();
				Basket.setCutoffTime(cutoffTimeRes);
				Basket.setTableNumber(tableNumber);
				// Basket.setProcessingFee();
				if (this.props.location.state && this.props.location.state.selectedRestaurant) {
					this.props.dispatch(loading(true))

					let ikentooMenusForLocation = await api.getIkentooMenusForLocation(businessLocationId);
					ikentooMenusForLocation = getMenusForSelectedTime(ikentooMenusForLocation, pickTime, choosenRestaurant.table_json_time_selector);
					if (ikentooMenusForLocation && isObject(ikentooMenusForLocation[0])) {
						let ikentooMenus = [];
						try {
							for (let i = 0; i < ikentooMenusForLocation.length; i++) {
								ikentooMenus.push(await api.getIkenooMenu(ikentooMenusForLocation[i].ikentooMenuId, businessLocationId, 'table'));
							}
						} catch (error) {
							this.setState({ error: 'Get restaurant menu error.' });
							this.setState({ continueButtonClicked: false });
							this.props.dispatch(loading(false))

						}
						const reorderItems = this.props.location.state.selectedRestaurant.items;
						const menu = this.getMenuForReorder(ikentooMenus, reorderItems);
						if (menu) {
							dispatch({
								type: SET_RESTAURANT_PROP,
								key: 'ikentooMenu',
								value: menu,
							});
							if (menu.flattenMenuItems.length > 0) {
								let validationStatus = {
									notBasketEmpty: false,
									validationError: false,
								};
								reorderItems.map((newBasketItem) => {
									let foundItem = menu.flattenMenuItems.find((i) => i.sku === newBasketItem.item.sku);
									if (foundItem && Basket.isProductEnabled(foundItem)) {
										if (newBasketItem?.selectedChoices?.length > 0) {
											newBasketItem.selectedChoices = Basket.filterReorderChoices(newBasketItem.selectedChoices, foundItem);
										}
										newBasketItem.item = foundItem;
										Basket.addToBasket(newBasketItem);
										let item = newBasketItem.item;
										let allergens = this.props.allergens;
										let profile = this.props.profile;
										let newArr = parseAllergenData(profile, item, allergens);
										let allergensCodes = newBasketItem.item?.itemRichData?.allergenCodes?.length > 0 ? newBasketItem.item.itemRichData.allergenCodes : [];
										if (allergensCodes.length > 0) {
											let allergensData = [{ allergens: newArr }, { sku: newBasketItem.item.sku }];
											Basket.setAllergen(allergensData);
										}
										validationStatus.notBasketEmpty = true;
									} else {
										validationStatus.validationError = true;
									}
								});
								if (validationStatus.notBasketEmpty) {
									if (validationStatus.validationError) {
										dispatch(showToast('Some items were not added to your basket as they are currently unavailable', 'warning'));
										this.setState({ continueButtonClicked: false });
									}
									forwardTo('/order-summary', {
										skipBackToThePreviousPage: false,
										stopLoading: true
									});
									this.setState({ continueButtonClicked: false });
								} else {
									dispatch(showToast('Some items were not added to your basket as they are currently unavailable', 'warning'));
									this.setState({ continueButtonClicked: false });
									this.props.dispatch(loading(false))

								}
							} else {
								dispatch(showToast('Menu not found', 'warning'));
								this.setState({ continueButtonClicked: false });
								this.props.dispatch(loading(false))

							}
						} else {
							dispatch(showToast('Menu not found', 'warning'));
							this.setState({ continueButtonClicked: false });
							this.props.dispatch(loading(false))

						}
					} else {
						dispatch(showToast('Menu not found', 'warning'));
						this.setState({ continueButtonClicked: false });
						this.props.dispatch(loading(false))

					}
				} else {
					dispatch(
						getIkentooMenusForLocation(businessLocationId, {
							pickTime,
							json_time_selector: choosenRestaurant ? choosenRestaurant.table_json_time_selector : [],
						}),
					);
					this.setState({ continueButtonClicked: false });
				}
			} else if (!selectedRestaurant) {
				this.setState({ error: __('Please select location') });
				this.setState({ continueButtonClicked: false });
			} else {
				this.setState({ error: __('Please enter table number') });
				this.setState({ continueButtonClicked: false });
			}
		});
	};
	checkForTableDisplay = () => {
		const searchParams = new URLSearchParams(this.props.location.search);
		if (Basket.has_multi_basket) {
			if (this.props.location?.state?.saveOrderData || searchParams.get('t_id')) {
				return false;
			}
		} else {
			if ((searchParams.get('t_id') && !searchParams.get('bl_id')) || !this.state.useSearchParams) {
				return false;
			}
		}
		return true;
	};
	position = async () => {
		try {
			if (isNative()) {
				const coordinates = await Geolocation.getCurrentPosition({
					enableHighAccuracy: true
				});

				this.props.dispatch(
					setMyLocation({
						latitude: coordinates.coords.latitude,
						longitude: coordinates.coords.longitude,
					}),
				);
				this.setState({
					isLocationAllowed: true,
				}, () => {
					this.props.dispatch(loading(false))

				});
			} else {
				navigator.geolocation.getCurrentPosition(
					(res) => {
						this.props.dispatch(
							setMyLocation({
								latitude: res?.coords?.latitude,
								longitude: res?.coords?.longitude,
							}),
						);
						this.setState({
							isLocationAllowed: true,
						}, () => {
							this.props.dispatch(loading(false))

						});
					},
					() => {
						this.setState(
							{
								isLocationAllowed: false,
								showTableNumber: this.checkForTableDisplay(),
							},
							() => {
								this.props.dispatch(loading(false))
								this.props.dispatch(setMyLocation({ latitude: null, longitude: null }));
							},
						);
					},
				);
			}
		} catch (error) {
			console.log('Location error:', error);
			this.setState(
				{
					isLocationAllowed: false,
					showTableNumber: this.checkForTableDisplay(),
				},
				() => {
					this.props.dispatch(loading(false))
					this.props.dispatch(setMyLocation({ latitude: null, longitude: null }));
				},
			);
		}

	};

	changeIkentooMenus = (event) =>
		this.setState({ selectedIkentooMenu: event.detail.value, error: '' }, () => {
			Basket.setMenu(event.detail.value);
		});

	continueOnMenu = () => {
		const { restaurants, dispatch } = this.props;
		const { selectedIkentooMenu, selectedRestaurant } = this.state;
		if (selectedRestaurant && selectedIkentooMenu) {
			const choosenRestaurant = restaurants.find((restaurant) => restaurant.id === selectedRestaurant);
			const businessLocationId = choosenRestaurant.business_location_id;
			dispatch(getIkentooMenu(selectedIkentooMenu, businessLocationId, true, 'table'));
		} else {
			this.setState({ error: 'Please select location menu' });
		}
	};
	backHandler = () => {
		if (this.state.showTableNumber || this.state.noTableRestaurants) {
			const defaultRoute = getDefaultRoute(this.props.navConfig);
			forwardTo(defaultRoute.path);
		} else {
			this.setState({ showTableNumber: true });
		}
	};
	getRestautantDataMessage = (id) => {
		const restaurant = this.props.restaurants.filter((restaurant) => restaurant.id === id);
		return `<p><b>${restaurant[0]?.name}</b></p> \n <p>${restaurant[0]?.address}</p>`;
	};
	checkTableNumbers = () => {
		const tableId = this.state.tableNumber;
		let valid = true;
		if (this.state.tableNumberPicker || this.state.checkTablePlan) {
			const tableData = this.formatMultiVenueTableNumbers().filter((table) => table.value == tableId);
			valid = tableData.length > 0;
		}
		if (valid) {
			Basket.setTableNumber(tableId);
			this.setState({
				tableNumber: tableId,
				showTableNumber: false,
				pickTime: moment(Date.now()).format('HH:mm'),
				tableNumberError: false,
			});
		} else {
			this.setState({ tableNumberError: true });
		}
	};
	isRestaurantOpenForReorder = (stores, restaurant) => {
		if (this.props.location?.state?.reorder) {
			const selectedRestaurant = stores?.find(el => el?.id == restaurant)
			if (selectedRestaurant) {
				return !selectedRestaurant.opened
			} else {
				return true
			}
		} else {
			return false
		}
	}
	render() {
		const { __, restaurants, isChooseMenuModalOpen, ikentooMenusForLocation } = this.props;
		const { selectedIkentooMenu, pickTime, selectedRestaurant, showTableNumber, noTableRestaurants, filterValue } = this.state;
		const stores = restaurants || [];
		const animationMenuClass = isChooseMenuModalOpen ? 'show-up' : '';
		const store = restaurants.find((restaurant) => restaurant.id === selectedRestaurant) || null;
		const menus = getMenusForSelectedTime(ikentooMenusForLocation, pickTime, store ? store.table_json_time_selector : []);
		const filteredRestaurants = restaurants.filter((store) => isDefined(store.can_table_order) && isDefined(store.is_published) && store.can_table_order && store.is_published);

		let formatedStores = this.formatDataForSelect(filteredRestaurants, noTableRestaurants);
		if (Basket.has_multi_basket && getConfig().flags.geolocationDisabled) {
			const stores = deepCopy(formatedStores);
			let openedRestaurants = stores.filter((store) => store.opened);
			let closedRestaurants = stores.filter((store) => !store.opened);
			openedRestaurants.sort((a, b) => {
				return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
			});
			openedRestaurants.sort((a, b) => a.sort_order - b.sort_order);
			closedRestaurants.sort((a, b) => {
				return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
			});
			closedRestaurants.sort((a, b) => a.sort_order - b.sort_order);
			formatedStores = [...openedRestaurants, ...closedRestaurants];
		}
		let filterReastaurants = formatedStores.filter(r =>
			r.name.toLowerCase().includes(filterValue.toLowerCase())
		);
		if (Basket.has_multi_basket) {
			filterReastaurants = filterReastaurants.filter(r => Basket.isRestaurantAllowed(r));
		}
		const tableDataFull = Basket.has_multi_basket ? this.formatMultiVenueTableNumbers() : this.formatTableNumberForSelect(this.state.selectedRestaurant)

		const normalizeTableNumber = (value) => `${value || ''}`.trim().toLowerCase().replace(/^table\s*/, '').trim();
		const tableQuery = normalizeTableNumber(this.state.tableFilterValue);
		const tableData = (tableDataFull || []).filter(item =>
			!tableQuery || normalizeTableNumber(item.text) === tableQuery
		);
		return (
			<Loading >
				<Layout
					showLoginIcon={getConfig().flags.hasGuestCheckout && Basket.itemsCount() == 0}
					showHamburger={(Basket.has_multi_basket ? this.state.showTableNumber : true) && !this.state.noTableRestaurants}
					backHandler={this.backHandler}
					title={__('Order to table')}
					headerWithTitle={true}
					color="transparent"
				>
					<div className={`${(!showTableNumber && getConfig().general.tiledRestaurantView) ? 'scrollable-y' : `flex-row-wrapper`} absolute-content box-with-shadow`}>
						{!showTableNumber && (
							<>
								{filterReastaurants?.length > 0 || filterValue !== '' ?
									<>
										<Title className="web-only page-title-centered">{__('Order to table')}</Title>

										<StrongText className='text-to-update page-title-centered'>{__('Select restaurant to start your order')}</StrongText>
										<Spacer size={2} />
										{!this.props.myLocation.latitude && getConfig().flags.hasDisabledLocationRestaurantsFilter &&
											<div className='restaurants-filter-wrapper'>
												<div className='box-content restaurants-filter-box'>
													<LocationDisabledIcon />

													<div>
														<SmallText className='bold'>{__('Location services unavailable')}</SmallText>
														<SmallText>{__('Please select your nearest store manually.')}</SmallText>

													</div>
												</div>
												<Spacer size={2} />
												<IonItem className='input-field-wrapper' lines='none'>
													<IonInput
														onIonInput={(e) => this.setState({ filterValue: e.target.value })}
														type="text"
														pattern="text"
														inputmode="text"
														placeholder={__('Search by store name or location')}
													/>
													<IonIcon icon={search} slot='start' />

												</IonItem>
												<Spacer size={2} />

											</div>
										}
										{Basket.has_multi_basket && <CuratedMenusLink saveOrderData={this.props.location?.state?.saveOrderData} />}
										<div className="order-locations-wrapper">
											<IonList className={` ${getConfig().general.tiledRestaurantView ? 'tiled-box-wrapper' : 'box-wrapper'}`}>
												{filterReastaurants.length > 0 ? <>

													{filterReastaurants.map((store, i) => (
														<React.Fragment key={`store_${i}`}>
															{getConfig().general.tiledRestaurantView ? (
																<IonItem
																	className="pointer box-wrapper"
																	disabled={!store.can_table_order || !store.opened || noTableRestaurants}
																	onClick={() => {
																		if (!Basket.has_multi_basket) {
																			this.setState({
																				selectedRestaurant: store.id,
																				isSubmitRestaurantAlertOpen: true,
																				forwardToOrdering: false,
																			});
																		} else {
																			this.setState({ selectedRestaurant: store.id }, () => {
																				this.selectRestaurant(store.id);
																				this.chooseMenusForLocation();
																			});
																		}
																	}}
																	lines="none"
																	key={i}
																>
																	<div style={{ width: '100%' }}>
																		<img src={store.image} />
																		<IonLabel>
																			<StrongText className='text-to-update block'>{__(store.name)}</StrongText>

																			<div className="restaurant-data" dangerouslySetInnerHTML={{ __html: store.info_html }}></div>
																		</IonLabel>
																		{!getConfig().flags.removeKitchenStatus &&
																			<SmallText className="restaurant-status">{store.kitchen_status.text}</SmallText>

																		}
																	</div>
																	<IonCheckbox className='round-checkbox' checked={selectedRestaurant && store.id === selectedRestaurant} slot="start" color="primary" />
																</IonItem>
															) : (
																<IonItem
																	key={i}
																	disabled={!store.opened || noTableRestaurants}
																	onClick={() =>
																		this.setState({
																			selectedRestaurant: store.id,
																		})
																	}
																	lines="none"
																	className="default-padding restaurant-wrapper"
																>
																	<IonLabel className="break-space">
																		<StrongText className='text-to-update block'>{__(store.name)}</StrongText>
																		<SmallText className="block">{__(store.address)}</SmallText>
																		{!getConfig().flags.removeKitchenStatus &&
																			<SmallText className={`kitchen-status-wrapper ${this.getKitchenStatusColor(store.kitchen_status.status)}-color`}>{store.kitchen_status.text}</SmallText>
																		}
																	</IonLabel>
																	<IonCheckbox className='round-checkbox' checked={selectedRestaurant && store.id === selectedRestaurant} slot="start" color="primary" />
																</IonItem>
															)}
														</React.Fragment>
													))}
												</> : <div className='centered'>
													<NormalText>{__('No locations found')}</NormalText>
												</div>}
											</IonList>
										</div>
										{!getConfig().general.tiledRestaurantView && (
											<>
												<Spacer size={5} />

												<IonButton
													disabled={noTableRestaurants || !selectedRestaurant || this.isRestaurantOpenForReorder(formatedStores, selectedRestaurant)}
													expand="block"
													color="primary"
													className='button-uppercase'
													onClick={() => {
														if (Basket.has_multi_basket) {
															this.setState({ tableFilterValue: '' }, () => {
																Basket.setRestaurant(this.props.restaurants.find((restaurant) => restaurant.id === this.state.selectedRestaurant));
																this.selectRestaurant(selectedRestaurant);
															})

														} else {
															this.setState({ tableFilterValue: '', isSubmitRestaurantAlertOpen: true, forwardToOrdering: false });
														}
													}}
												>
													{__('Continue')}
												</IonButton>
											</>
										)}
									</> :
									<div className='centered'>
										<StrongText className='text-to-update page-title-centered'>{__('Sorry, order to table is not available at this time...')}</StrongText>

									</div>
								}
							</>
						)}
						{showTableNumber && (
							<>
								<Title className="web-only page-title-centered">{__('Order to table')}</Title>
								{!Basket.has_multi_basket &&
									<>
										<StrongText className="text-to-update page-title-centered">{__('Confirm your location and table')}</StrongText>
										<Spacer size={2} />
									</>
								}
								<div className={`order-locations-wrapper ${Basket.has_multi_basket ? 'order-locations-wrapper-flex-unset' : ''}`}>
									{!Basket.has_multi_basket && (
										<>
											<IonList className="box-wrapper no-padding">
												<IonItem className="box-content unclickable restaurant-wrapper" key={selectedRestaurant} lines="none">
													<div tabIndex="-1"></div>
													<IonCheckbox className='round-checkbox' color="primary" slot="start" checked />
													<IonLabel className="break-space" color="dark">
														<StrongText >
															{this.state.selectedRestaurantFull ? this.state.selectedRestaurantFull.name : Basket.getRestaurant()?.name}
														</StrongText>
														<SmallText className="block">
															{this.state.selectedRestaurantFull ? this.state.selectedRestaurantFull.address : Basket.getRestaurant()?.address}
														</SmallText>
														{!getConfig().flags.removeKitchenStatus &&

															<SmallText
																className={`${this.getKitchenStatusColor(
																	this.state.selectedRestaurantFull
																		? this.state.selectedRestaurantFull.kitchen_status.status
																		: Basket.getRestaurant()?.kitchen_status.status,
																)}-color kitchen-status-wrapper`}
															>
																{this.state.selectedRestaurantFull ? this.state.selectedRestaurantFull.kitchen_status.text : Basket.getRestaurant()?.kitchen_status.text}
															</SmallText>
														}
													</IonLabel>
												</IonItem>
											</IonList>
											<Spacer size={5} />
											{filteredRestaurants.length > 1 && !this.state.useSearchParams ? (
												<><IonButton
													expand="block"

													color="secondary"
													className="link"
													onClick={() =>
														this.setState({
															selectedRestaurant: null,
															showTableNumber: false,
															tableNumber: null,
															totalTableNumbers: [],
															filterValue: ''
														})
													}
												>
													{__('At a different location?')}
												</IonButton>
													<Spacer size={5} /></>
											) : (
												<></>
											)}
										</>
									)}


									<div className={`input-field-container ${Basket.has_multi_basket ? 'multi-venue-table-picker' : ''}`}>
										<StrongText className='block text-to-update'>{__('Table Number')}</StrongText>
										{Basket.has_multi_basket ? (
											<>
												{this.state.tableNumberPicker ? (
													<>
														{getConfig().flags.hasTableFilterOption &&
															<>
																<IonItem className='input-field-wrapper'>
																	<IonIcon slot="start" icon={searchOutline}></IonIcon>
																	<IonInput
																		value={this.state.tableFilterValue}
																		onIonInput={(e) => {
																			this.setState({ tableNumber: null, tableFilterValue: e.target.value })
																		}}
																		placeholder={__('Search table... (e.g., 20)')}
																	></IonInput>
																</IonItem>
																<Spacer size={2} />
															</>
														}
														<div className="time-picker-wrapper box-wrapper">

															{tableData.length > 0 ?
																<SelectOption
																	theme='ios'
																	cssClass={(isWebConfig() ? 'web ' : '') + (this.state.tableNumber ? '' : 'no-initial-selection')}
																	inputStyle="box"
																	display="inline"
																	{...(getConfig().tablePlan && getConfig().tablePlan.length > 1 && { group: { header: true, groupWheel: false, clustered: false } })}
																	data={tableData}
																	value={this.state.tableNumber || null}
																	onSet={(e, a) => this.selectTableNumber(e, a)}
																	// onInit={() => {
																	// 	if (tableData.length > 0) {
																	// 		if (!this.state.tableNumber && tableData[0]) {
																	// 			this.setState({
																	// 				tableNumber: tableData[0].value,
																	// 			});
																	// 			Basket.setTableNumber(tableData[0].value);
																	// 		}
																	// 	}
																	// }}
																/>
																:
																<div className='box-content'>
																	<NormalText>{__('No results')}</NormalText>
																</div>
															}

														</div>
													</>

												) : (
													<IonItem lines="none" className="input-field-wrapper">
														<IonInput
															className="table-number-input"
															onIonInput={(e) => {
																const inputValue = e.target.value || '';
																this.setState({
																	tableNumber: inputValue.replace(/^0/, '')
																});
															}}
															value={this.state.tableNumber}
															type="number"
															inputmode="tel"
															min={1}
															placeholder={__('Enter table number')}
														/>
													</IonItem>
												)}
											</>
										) : (
											<>
												{this.state.tableNumberPicker ? (
													<>
														{getConfig().flags.hasTableFilterOption &&
															<>
																<IonItem className='input-field-wrapper'>
																	<IonIcon slot="start" icon={searchOutline}></IonIcon>

																	<IonInput
																		value={this.state.tableFilterValue}

																		onIonInput={(e) => {
																			this.setState({ tableNumber: null, tableFilterValue: e.target.value })
																		}}
																		placeholder={__('Search table... (e.g., 20)')}
																	></IonInput>
																</IonItem>
																<Spacer size={2} />
															</>
														}


														<div className="time-picker-wrapper box-wrapper">
															{tableData.length > 0 ?

																<SelectOption
																	theme='ios'
																	cssClass={(isWebConfig() ? 'web ' : '') + (this.state.tableNumber ? '' : 'no-initial-selection')}
																	display="inline"
																	label="Table Number"
																	inputStyle="box"
																	setText={__('OK')}
																	cancelText={__('Cancel')}
																	data={tableData}
																	value={this.state.tableNumber}
																	onSet={(e, a) => this.selectTableNumber(e, a)}
																	// onInit={() => {
																	// 	if (tableData.length > 0 && !this.state.tableNumber) {
																	// 		this.setState({
																	// 			tableNumber: tableData[0].value,
																	// 		}, () => {
																	// 			Basket.setTableNumber(tableData[0].value);

																	// 		});
																	// 	}
																	// }}
																/>
																:
																<div className='box-content'>
																	<NormalText>{__('No results')}</NormalText>
																</div>
															}
														</div>

													</>
												) : (
													<IonItem lines="none" className="input-field-wrapper">
														<IonInput
															className="table-number-input"
															onIonInput={(e) => {
																const inputValue = e.target.value || '';

																this.setState({
																	tableNumber: inputValue.replace(/^0/, '')
																});
															}}
															value={this.state.tableNumber}
															type="number"
															inputmode="tel"
															placeholder={__('Enter table number')}
														/>
													</IonItem>
												)}
											</>
										)}
									</div>
									{this.state.tableNumberError && <FieldError className="field-error" value={__('Invalid table number. Please double-check and try again.')} />}

									{getConfig().frenchDisclaimer?.disclaimerImage && (
										<div className="disclaimer-wrapper">
											<img src={getConfig().frenchDisclaimer?.disclaimerImage}></img>
										</div>
									)}
								</div>
								{!Basket.has_multi_basket &&
									<Spacer size={5} />

								}
								<IonButton
									disabled={this.state.tableNumber ? false : true}
									expand="block"
									color="primary"
									{...(getConfig()?.customButtons?.order?.table && { style: { '--ion-color-primary': getConfig()?.customButtons?.order?.table } })}
									className={`${this.state.continueButtonClicked ? 'unclicked' : ''} button-uppercase`}
									onClick={() => {
										if (Basket.has_multi_basket) {
											const selectedTableData = tableData.find(el => el.value == this.state.tableNumber)
											Basket.setAllowedRestaurantIds(selectedTableData?.allowed_restaurant_ids || []);
											if (this.state.checkTablePlan) {
												this.checkTableNumbers();
											} else {
												Basket.setTableNumber(this.state.tableNumber);

												this.setState({
													showTableNumber: false,
													pickTime: moment(Date.now()).format('HH:mm'),
												});
											}
										} else {
											if (filteredRestaurants.length > 1) {
												this.setState({ isSubmitRestaurantAlertOpen: true, forwardToOrdering: true });
											} else {
												this.chooseMenusForLocation();
											}
										}
									}}
								>
									{__('Continue')}
								</IonButton>
							</>
						)}
					</div>

					{!menus.length ? null : (
						<>
							<Modal
								isOpen={isChooseMenuModalOpen}
								onDidDismiss={() => this.props.dispatch(setCommonModal('isChooseMenuModalOpen', false))}
							>
								<Title className='modal-title'>{__('Choose menu')}</Title>
								<Spacer size={5} />
								<IonList lines="none" className="box-wrapper menus-wrapper">
									<IonRadioGroup onIonChange={this.changeIkentooMenus} value={selectedIkentooMenu}>
										{menus.length === 0 ? (
											<NoData />
										) : (
											menus.map((menu) => {
												const { ikentooMenuId, menuName } = menu;
												return (
													<IonItem key={ikentooMenuId} lines="none">
														<StrongText className="ion-text-wrap" >
															{menuName}
														</StrongText>
														<IonRadio color='primary' slot="start" value={ikentooMenuId} />
													</IonItem>
												);
											})
										)}
									</IonRadioGroup>
								</IonList>
								<Spacer size={5} />
								<IonButton
									disabled={pickTime && menus.length > 0 ? false : true}
									expand="block"
									color="primary"
									className="button-uppercase"
									onClick={() => this.continueOnMenu()}
								>
									{__('Continue')}
								</IonButton>
							</Modal>
						</>
					)}
				</Layout>
				<IonAlert
					isOpen={this.state.isSubmitRestaurantAlertOpen}
					onDidDismiss={() => this.setState({ isSubmitRestaurantAlertOpen: false })}
					header={__('Please confirm you are in this location')}
					message={__(this.getRestautantDataMessage(selectedRestaurant))}
					buttons={[
						{
							text: __('Confirm'),
							role: 'submit',
							cssClass: 'primary',
							handler: () => (this.setState({ isSubmitRestaurantAlertOpen: false }, () => { this.state.forwardToOrdering ? this.chooseMenusForLocation() : this.selectRestaurant(selectedRestaurant) })),
						},
						{
							text: this.state.forwardToOrdering ? __('Change') : __('Cancel'),
							role: 'cancel',
							cssClass: 'link secondary',
							handler: () => (this.state.forwardToOrdering ? this.setState({ showTableNumber: false, forwardToOrdering: false, isSubmitRestaurantAlertOpen: false }) : this.setState({ isSubmitRestaurantAlertOpen: false })),
						},

					]}
				/>
			</Loading>
		);
	}
}

const stateToProps = (state) => {
	const { deliveryOption } = state.orders;
	const { restaurants, ikentooMenusForLocation } = state.restaurants;
	const { isChooseMenuModalOpen, navConfig, myLocation } = state.common;
	const { auth } = state.profile;

	return {
		navConfig,
		deliveryOption,
		restaurants: restaurants || [],
		profile: state.profile.profile,
		isChooseMenuModalOpen: isChooseMenuModalOpen,
		ikentooMenusForLocation: ikentooMenusForLocation || [],
		auth,
		myLocation
	};
};

export default connect(stateToProps)(withTranslation(OrderToTable));
